import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=97b46248&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=ts&"
export * from "./Contract.vue?vue&type=script&lang=ts&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=97b46248&scoped=true&lang=scss&"
import style1 from "./Contract.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b46248",
  null
  
)

export default component.exports